<template>
  <div class="animation-content">
    <p>Deliver</p>
    <p class="sokoDeep--text">
      <span>
        <span class="move">Food</span>
        <span class="move">Money</span>
        <span class="move">Cars</span>
        <span class="move">Clothing</span>
        <span class="move">Groceries</span>
        <span class="move">Anything</span>
      </span>
    </p>
    <p>Anywhere!</p>
  </div>
</template>

<script>
export default {
  name: "AnimatedText",

  data: () => ({
    li: 0,
  }),

  methods: {
    playAnimation() {
      this.moveItems[this.li].style.display = "none";
      if (this.li >= this.moveItems.length - 1) this.li = 0;
      else this.li++;
      this.moveItems[this.li].style.display = "block";
      setTimeout(() => {
        this.playAnimation();
      }, 3000);
    },
  },

  computed: {
    moveItems() {
      return document.querySelectorAll(".move");
    },
  },

  mounted() {
    this.playAnimation();
  },
};
</script>

<style scoped>
* {
  font-family: "Titan One", cursive;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-size: 16px;
}

.animation-content {
  line-height: 100%;
}

@media (min-width: 960px) {
  .animation-content {
    font-size: 3.5rem;
  }
}

@media (max-width: 960px) {
  .animation-content {
    font-size: 3rem;
  }
}

.animation-content p {
  color: #5c5c5c;
}

.move {
  display: none;
  animation-name: slide-right;
  animation-duration: 3s;
  animation-iteration-count: infinite;
}

@keyframes slide-right {
  0% {
    margin-left: -100%;
    opacity: 0;
  }
  5%,
  55% {
    margin-left: 0;
    opacity: 1;
    display: block;
  }
  100% {
    margin-left: 15%;
    opacity: 0;
  }
}
</style>
